module.exports = __webpack_public_path__ + "img/video-not-found.c23c5d4b.png";